import React, {useEffect, useState} from 'react';
import './App.css';
import {useForm} from "react-hook-form";

import axios from 'axios';


import './assets/less/style.less';
import solowka from './assets/img/bus.svg';
import ciagnik from './assets/img/truck.svg';
import naczepa from './assets/img/trailer.svg';
import arrow from './assets/img/arrow.svg';
import checkbox from './assets/img/checkbox.svg';

const URL_WP_ADMIN_AJAX_REGISTER_POLICY = 'https://inpl.eu/wp-admin/admin-ajax.php?action=registernewinsurancepolicy';
const URL_WP_ADMIN_AJAX_UPDATE_POLICY = 'https://inpl.eu/wp-admin/admin-ajax.php?action=updateemailinsurancepolicy' ;

//const URL_WP_ADMIN_AJAX_REGISTER_POLICY = 'http://localhost/truckpolisa/wp-admin/admin-ajax.php?action=registernewinsurancepolicy';
//const URL_WP_ADMIN_AJAX_UPDATE_POLICY = 'http://localhost/truckpolisa/wp-admin/admin-ajax.php?action=updateemailinsurancepolicy';

type Inputs = {
    rodzajPojazdu: number,
    exampleRequired: string,
    selectYear: number,
    inputPrice: number,
    leasing: string,
    gps: string,
    rodzajPolisy: number,
};

type Calculations = {
    oc: number,
    ac: number,
    nnw: number,
}

function App() {

    const {register, handleSubmit, watch, errors} = useForm<Inputs>();

    const [showStep1, setShowStep1] = useState(true);
    const [showStep2, setShowStep2] = useState(false);
    const [showStep3, setShowStep3] = useState(false);
    const [showStep4, setShowStep4] = useState(false);
    const [showStepBack, setShowStepBack] = useState(false);
    const [showThankYou, setThankYou] = useState(false);

    const [selectedTypeOfLeasing, setSelectedTypeOfLeasing] = useState('');

    const [calculations, setCalculations] = useState<Calculations>({oc: 0, ac: 0, nnw: 0});
    const [createdInsurancePolicyID, setCreatedInsurancePolicyID] = useState(-1);
    const [clientEmail, setClientEmail] = useState('');

    let lastYears: Array<number> = []
    const currentYear: number = new Date().getFullYear()

    for (var i = 0; i < 10; i++) lastYears.push(currentYear - i)

    const onSubmit = (data: Inputs) => {

        let baseAc = 0;
        let vehicleAge = currentYear - data.selectYear

        if (+data.rodzajPojazdu === 1) { // Solo

            if (vehicleAge === 0 || vehicleAge === 1) baseAc = 0.0115 * data.inputPrice
            else if (vehicleAge === 2) baseAc = 0.012 * data.inputPrice
            else if (vehicleAge === 3) baseAc = 0.014 * data.inputPrice
            else if (vehicleAge === 4) baseAc = 0.020 * data.inputPrice
            else if (vehicleAge === 5) baseAc = 0.020 * data.inputPrice
            else if (vehicleAge >= 6 && vehicleAge <= 8) baseAc = 0.020 * data.inputPrice
            else if (vehicleAge === 9 || vehicleAge === 10) baseAc = 0.025 * data.inputPrice

        } else if (+data.rodzajPojazdu === 2) { // Truck

            if (vehicleAge === 0 || vehicleAge === 1) baseAc = 0.013 * data.inputPrice
            else if (vehicleAge === 2) baseAc = 0.015 * data.inputPrice
            else if (vehicleAge === 3) baseAc = 0.017 * data.inputPrice
            else if (vehicleAge === 4) baseAc = 0.017 * data.inputPrice
            else if (vehicleAge === 5) baseAc = 0.019 * data.inputPrice
            else if (vehicleAge >= 6 && vehicleAge <= 8) baseAc = 0.019 * data.inputPrice
            else if (vehicleAge === 9 || vehicleAge === 10) baseAc = 0.027 * data.inputPrice

        } else if (+data.rodzajPojazdu === 3) { // Trailers

            if (vehicleAge === 0 || vehicleAge === 1) baseAc = 0.011 * data.inputPrice
            else if (vehicleAge === 2) baseAc = 0.013 * data.inputPrice
            else if (vehicleAge === 3) baseAc = 0.015 * data.inputPrice
            else if (vehicleAge === 4) baseAc = 0.016 * data.inputPrice
            else if (vehicleAge === 5) baseAc = 0.017 * data.inputPrice
            else if (vehicleAge >= 6 && vehicleAge <= 8) baseAc = 0.018 * data.inputPrice
            else if (vehicleAge === 9 || vehicleAge === 10) baseAc = 0.027 * data.inputPrice

        }

        const baseOc = +data.rodzajPojazdu === 1 ? 3200 : (+data.rodzajPojazdu === 2 ? 5200 : 320)
        const calculatedAc = (baseAc) - (data.gps === 'yes' ? baseAc * 0.1 : 0) + (data.leasing === 'yes' ? baseAc * 0.05 : 0)
        let calculatedOc = (baseOc) + (data.leasing === 'yes' ? baseOc * 0.05 : 0) // wyjatek, moze sie zmienic

        if(+data.rodzajPolisy === 2) { // wyjatek na zyczenie klienta, ciagnik, oc w ruchu krajowym
            if(+data.rodzajPojazdu === 1) calculatedOc = 3200
            if(+data.rodzajPojazdu === 2) calculatedOc = 4600
            if(+data.rodzajPojazdu === 3) calculatedOc = 320
        }

        if(+data.rodzajPolisy === 3) { // wyjatek na zyczenie klienta, ciagnik, oc w ruchu krajowym
            if(+data.rodzajPojazdu === 1) calculatedOc = 3200
            if(+data.rodzajPojazdu === 2) calculatedOc = 5200
            if(+data.rodzajPojazdu === 3) calculatedOc = 320
        }


        setCalculations({
            ac: (+data.rodzajPolisy === 1 ? calculatedAc : 0 ),
            oc: calculatedOc,
            nnw: (+data.rodzajPolisy === 1 ? 35 : 0),
        })


        //console.log(calculations)


        setShowStep1(false)
        setShowStep3(true)
    }

    /*
        @param userChoice - Pass boolean if the user want to generate new offer or just calculate
    */
    const onSubmitStep3 = async (userChoice: boolean) => {

        setShowStep3(false)

        //console.log(calculations)

        //console.log(calculations)

        if (userChoice) {
            setShowStep2(true)
            //console.log(calculations)

            const data = {
                '_tp_status': 'Gotowa',
                '_tp_car_type': (+watch('rodzajPojazdu') === 1 ? 'Solówka' : (+watch('rodzajPojazdu') === 2 ? 'Ciągnik' : 'Naczepa')),
                '_tp_car_year': (+watch('selectYear')),
                '_tp_gps': (watch('gps') === 'yes' ? 'Tak' : 'Nie'),
                '_tp_leasing': (watch('leasing') === 'yes' ? 'Tak' : 'Nie'),
                '_tp_value': (watch('inputPrice')) + ' zł',
                '_tp_all_value': (calculations.oc + calculations.ac + calculations.nnw).toLocaleString("fr", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }) + ' zł',
                '_tp_type': (+watch('rodzajPolisy') === 1 ? 'Pakiet OC, AC, NNW' : (+watch('rodzajPolisy') === 2 ? 'OC w ruchu krajowym' : 'OC Polska i Europa')),
                '_tp_email': '-',
                '_tp_promo_code': '-',
            }

            try {
                let res = await axios.post(URL_WP_ADMIN_AJAX_REGISTER_POLICY, data, {headers: {}})

                //console.log(res.data.post_id)

                setCreatedInsurancePolicyID(res.data.post_id)
                setShowStep2(false)
                setShowStep4(true)
            } catch (e) {
                console.log(e)
                alert('Wystąpił błąd z generowaniem twojej polisy 🤷‍♂️😢 Skontaktuj się z administartorem serwisu lub napisz do nas maila 🚛')
            }

        } else {
            setShowStepBack(true)
        }
    }

    const handleKeyDown = (e: any) => {
        if (e.keyCode === 13) onSubmitStep4()
    }

    const onSubmitStep4 = async () => {
        //...

        setShowStepBack(false)
        setShowStep4(false)
        setShowStep2(true)

        //console.log(`SUBMIT! => ${createdInsurancePolicyID}`)
        //console.log(clientEmail)

        const data = {
            '_post_id': createdInsurancePolicyID,
            '_tp_email': clientEmail,
        }

        try {
            let res = await axios.post(URL_WP_ADMIN_AJAX_UPDATE_POLICY, data, {headers: {}})
            //console.log(res.data.code)
            setShowStep2(false)
            setThankYou(true)
        } catch (e) {
            console.log(e)
            alert('Wystąpił błąd z generowaniem twojej polisy 🤷‍♂️😢 Skontaktuj się z administartorem serwisu lub napisz do nas maila 🚛')
        }


    }

    const validateTypeOfLeasingInputs = (value: number) => {

        if (+value === 1) {
            return true
        } else if (+value === 2) {
            if (watch('leasing') === 'yes' || +watch('rodzajPojazdu') === 3) {
                return false
            }
        } else if (+value === 3) {
            if (watch('leasing') === 'yes') {
                return false
            }
        } else {
            return true
        }
    }

    let boolVehInLeasing = watch('leasing')

    useEffect(() => {
        if (boolVehInLeasing === 'yes') setSelectedTypeOfLeasing('1')
    }, [boolVehInLeasing])


    //console.log(watch("rodzajPojazdu")) // watch input value by passing the name of it


    return (
        <div className="App">
            <div className="container widget-calculator">
                <div id="step1" className={showStep1 ? '' : 'hidden'}>
                    <h2>Oblicz swoją składkę ubezpieczeniową</h2>
                    <form id="calculationsForm" onSubmit={handleSubmit(onSubmit)}>
                        <div id="box-pojazdy">
                            <h3>Wybierz rodzaj pojazdu</h3>
                            <div className="row box-pojazdy-row gutter-5">
                                <div className="col-md-4">
                                    <div className="input-box">
                                        <div className="input-box__wrapper">
                                            <input type="radio" id="solowka" name="rodzajPojazdu" value="1"
                                                   ref={register({required: true})}/>
                                            <label htmlFor="solowka" className="label">
                                                <span className="circle"></span>
                                                Solówka
                                                <img alt="Just a svg" src={solowka} className="icon"/>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-box">
                                        <div className="input-box__wrapper">
                                            <input type="radio" id="ciagnik" name="rodzajPojazdu" value="2"
                                                   ref={register({required: true})}/>
                                            <label htmlFor="ciagnik" className="label">
                                                <span className="circle"></span>
                                                Ciągnik

                                                <img alt="Just a svg" src={ciagnik} className="icon"/>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-box">
                                        <div className="input-box__wrapper">
                                            <input type="radio" id="naczepa" name="rodzajPojazdu" value="3"
                                                   ref={register({required: true})}/>
                                            <label htmlFor="naczepa" className="label">
                                                <span className="circle"></span>
                                                Naczepa
                                                <img alt="Just a svg" src={naczepa} className="icon"/>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {errors.rodzajPojazdu &&
                            <div className="alert alert-danger" role="alert">
                                Wybierz rodzaj pojazdu.
                            </div>
                            }
                        </div>
                        <div className="d-inline-block">
                            <h3>Dane pojazdu</h3>
                            <div className="input-normal-box" id="yearBox">
                                <label htmlFor="year">Rok produkcji</label>
                                <select name="selectYear" id="year" defaultValue="" ref={register({required: true})}>
                                    <option value="" hidden>Wybierz rok</option>
                                    {lastYears.map((val, i) =>
                                        (<option key={i} value={val}>{val}</option>)
                                    )}
                                </select>
                            </div>
                            {errors.selectYear &&
                            <div className="alert alert-danger" role="alert">
                                Wybierz rok produkcji pojazdu.
                            </div>
                            }
                            <div className="input-normal-box" id="priceBox">
                                <label htmlFor="price">Cena pojazdu (netto)</label>
                                <input type="number" name="inputPrice" id="price" pattern="[0-9]" min="1" max="1000000"
                                       placeholder="max: 1 000 000 PLN"
                                       ref={register({required: true, min: 1, max: 999999})}/>
                            </div>
                            {errors.inputPrice?.type === 'min' &&
                            <div className="alert alert-danger" role="alert" id="PriceToLow">
                                Podana cena jest zbyt niska.
                            </div>
                            }
                            {errors.inputPrice?.type === 'max' &&
                            <div className="alert alert-danger" role="alert" id="PriceToHigh">
                                Podana cena jest zbyt wysoka.
                            </div>
                            }
                            {errors.inputPrice &&
                            <div className="alert alert-danger" role="alert">
                                Podaj cenę pojazdu (netto).
                            </div>
                            }


                            <div className="input-bool-box" id="gpsBox">
                                <span className="name">Pojazd posiada GPS?</span>
                                <input type="radio" name="gps" id="gps-yes" value="yes"
                                       ref={register({required: true})}/><label
                                htmlFor="gps-yes"><span>TAK</span></label><input type="radio" name="gps" id="gps-no"
                                                                                 value="no"
                                                                                 ref={register({required: true})}/><label
                                htmlFor="gps-no"
                                className="label-last"><span>NIE</span></label>
                            </div>
                            {errors.gps &&
                            <div className="alert alert-danger" role="alert">
                                Zaznacz odpowiednią opcję.
                            </div>
                            }
                            <div className="input-bool-box" id="leasingBox">
                                <span className="name">Pojazd jest w leasingu?</span>

                                <input type="radio" name="leasing" id="leasing-yes" value="yes"
                                       ref={register({required: true})}/><label
                                htmlFor="leasing-yes"><span>TAK</span></label><input type="radio" name="leasing"
                                                                                     id="leasing-no" value="no"
                                                                                     ref={register({required: true})}/><label
                                htmlFor="leasing-no" className="label-last"><span>NIE</span></label>
                            </div>
                            {errors.leasing &&
                            <div className="alert alert-danger" role="alert">
                                Zaznacz odpowiednią opcję.
                            </div>
                            }

                        </div>
                        <div id="box-polisy">
                            <h3>Wybierz rodzaj polisy</h3>
                            <div className="row gutter-5">
                                <div className="col-md-4">
                                    <div id="pakietBox" className="input-box">
                                        <div className="input-box__wrapper">
                                            <input type="radio" id="pakietInput" name="rodzajPolisy" value="1"
                                                   onChange={() => setSelectedTypeOfLeasing(('1'))}
                                                   checked={selectedTypeOfLeasing === '1'}
                                                   ref={register({
                                                       required: true,
                                                       validate: value => validateTypeOfLeasingInputs(value)
                                                   })}/>
                                            <label htmlFor="pakietInput" className="label">
                                                <span className="circle"></span>
                                                Pakiet OC, AC, NNW
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div id="wruchuBox"
                                         className={watch('leasing') === 'yes' || +watch('rodzajPojazdu') === 3 ? 'input-box input-box--disabled' : 'input-box'}>
                                        <div className="input-box__wrapper">
                                            <input type="radio" id="wruchuInput" name="rodzajPolisy" value="2"
                                                   onChange={() => setSelectedTypeOfLeasing(('2'))}
                                                   checked={selectedTypeOfLeasing === '2' && +watch('rodzajPojazdu') !== 3}
                                                   ref={register({
                                                       required: true,
                                                       validate: value => validateTypeOfLeasingInputs(value)
                                                   })}/>
                                            <label htmlFor="wruchuInput" className="label">
                                                <span className="circle"> </span>
                                                OC w ruchu krajowym
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div id="plieuBox"
                                         className={watch('leasing') === 'yes' ? 'input-box input-box--disabled' : 'input-box'}>
                                        <div className="input-box__wrapper">
                                            <input type="radio" id="plieuInput" name="rodzajPolisy" value="3"
                                                   onChange={() => setSelectedTypeOfLeasing(('3'))}
                                                   checked={selectedTypeOfLeasing === '3'}
                                                   ref={register({
                                                       required: true,
                                                       validate: value => validateTypeOfLeasingInputs(value)
                                                   })}/>
                                            <label htmlFor="plieuInput" className="label">
                                                <span className="circle"></span>
                                                OC Polska i Europa
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {(errors.rodzajPolisy && (selectedTypeOfLeasing !== '1')) &&
                                <div className="alert alert-danger" role="alert">
                                    Wybierz odpowiedni rodzaj polisy.
                                </div>
                            }
                        </div>
                        <button type="submit" className="submit">Oblicz <img alt="Just a svg" src={arrow}
                                                                             className="arrow"/></button>

                        <div id="output"></div>
                    </form>
                </div>
                <div id="step2" className={showStep2 ? '' : 'hidden'}>
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div id="step3" className={showStep3 ? '' : 'hidden'}>
                    <h2 className="heading">Wysokość składki
                        wynosi:<span>{(calculations.ac + calculations.oc + calculations.nnw).toFixed(2)} PLN</span></h2>
                    <form>
                        <div className="input-bool-box">
                            <span className="name">Czy stawka ci odpowiada?</span>
                            <input type="radio" name="price-accept" id="price-accept-yes" value="yes"
                                   onClick={() => onSubmitStep3(true)} required/>
                            <label htmlFor="price-accept-yes"><span>TAK</span></label><input type="radio"
                                                                                             name="price-accept"
                                                                                             id="price-accept-no"
                                                                                             onClick={() => onSubmitStep3(false)}
                                                                                             value="no" required/><label
                            htmlFor="price-accept-no" className="label-last"><span>NIE</span></label>
                        </div>
                    </form>
                </div>
                <div id="stepBack" className={showStepBack ? '' : 'hidden'}>
                    <div className="d-flex justify-content-center">
                        <h2>Dziękujemy za skorzystanie z naszego kalkulatora</h2>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button className="submit" onClick={() => window.location.reload(false)}>Wróć do formularza</button>
                    </div>
                </div>
                <div id="step4" className={showStep4 ? '' : 'hidden'}>
                    <h3 className="heading">Twój kod Truck Polisy
                        to: <span>TP-2020/{createdInsurancePolicyID}</span> Dzięki niemu będziemy
                        cię
                        identyfikować.</h3>
                    <p className="info"><i className="far fa-envelope"></i> Jeśli podasz nam swój email, prześlemy Ci
                        Twoją
                        kalkulację wraz z wygenerowanym kodem Truck Polisa.</p>

                    <div className="input-normal-box" id="emailBox">
                        <label htmlFor="email">Twój email</label>
                        <input type="email" name="email" placeholder="Twój email" id="email" value={clientEmail}
                               onKeyDown={(e) => handleKeyDown(e)} onChange={(e) => setClientEmail(e.target.value)}/>
                    </div>
                    <button className="submit mb-5" onClick={() => onSubmitStep4()}>Wyślij <img alt="Just a svg"
                                                                                                src={arrow}
                                                                                                className="arrow"/>
                    </button>

                    <div className="clauses">
                        {watch("leasing") === 'yes' &&
                        <p className="clauses__paragraph"><span className="clauses__point">Leasing</span>Zaznaczyłeś, że
                            twoje auto jest w leasingu. Informujemy, że niektóre firmy leasingowe wymagają zgłoszenia
                            wznowienia polisy w ściśle określonym terminie np. Alior Leasing i Idea Getin Leasing
                            najpóźniej
                            30 dni przed końcem wygasającej polisy. W przypadku PKO Leasing, Millennium Leasing i EFL
                            jest
                            to 15 dni. Sprawdź dokładnie kiedy kończy się Twoja obecna polisa
                        </p>
                        }
                        <p className="clauses__paragraph">Niniejsza kalkulacja nie stanowi oferty w rozumieniu art. 66 i
                            następnych Kodeksu Cywilnego. Truck Polisa zastrzega sobie prawo do zmiany składki przed
                            zawarciem polisy.
                        </p>
                        <p className="clauses__paragraph">Pamiętaj, że nie pobieramy Twoich danych osobowych. Dlatego
                            podanie ich u brokera najczęściej blokuje możliwość skorzystania z naszej oferty. Jeżeli
                            zależy
                            Ci na niskiej składce jak najszybciej skontaktuj się pracownikami Truck Polisy.
                        </p>
                        <p className="clauses__paragraph">Zgodnie z art. 13 Rozporządzenia Parlamentu Europejskiego i
                            Rady
                            (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO) informuję, że administratorem Pani/Pana
                            danych
                            osobowych jest firma TRUCK POLISA Jan Makarewicz z siedzibą w Warszawie ul. Dzieci Warszawy
                            11
                            lok.30 . Dane osobowe będą przetwarzane w celu komunikacji dot. przedmiotu umowy pomiędzy
                            Administratorem a Panią/Panem (na podstawie art. 6, ust. 1, lit b RODO). Dane mogą być
                            udostępniane wyłącznie podmiotom współpracującym z Administratorem w celu realizacji
                            współpracy
                            i komunikacji z Panią/Panem. Przysługuje Pani/Panu prawo dostępu, sprostowania,
                            przenoszenia,
                            sprzeciwu wobec przetwarzania, ograniczenia przetwarzania, prawo do usunięcia swoich danych
                            oraz
                            prawo wniesienia skargi do organu nadzorczego. Pani/Pana dane osobowe będą przetwarzane
                            przez
                            czas realizacji przedmiotu umowy oraz po jej zakończeniu w celu zachowania niezaburzonego
                            procesu komunikacji dot. możliwości dalszej współpracy. Podanie danych jest dobrowolne.</p>
                    </div>
                </div>
                <div className={showThankYou ? 'box-thanks' : 'box-thanks hidden'} id="stepThanks">
                    <div className="check-box">
                        <img alt="Check icon" src={checkbox}/>
                    </div>
                    <h3>Twoja polisa zostałą wysłana.</h3>
                    <h2>Dziękujemy za skorzystanie z kalkulatora</h2>
                    <div className="d-flex justify-content-center">
                        <button className="submit" onClick={() => window.location.reload(false)}>Wróć do formularza</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
